import React, { useState, useEffect } from "react";
import FlatList from "flatlist-react";
import { ToastContainer } from "react-toastify";
import apilink from "../apiURL/baseUrls";
import axios from "axios";
import moment from "moment";
import "react-activity/dist/library.css";
import './Table.css';
import { addRecord, getAllRecords, PRODUCT_STORE, RATE_STORE, getLastSalesId, SALES_STORE } from "../dbControllers/dbController";

const monies = [
    { id: 1, currency: 'ZWL', collected: 120000, usdRate: 13.5 },
    { id: 2, currency: 'USD', collected: 450, usdRate: 1 },
    { id: 3, currency: 'ZAR', collected: 8000, usdRate: 18.2 },
    { id: 4, currency: 'BWP', collected: 2500, usdRate: 13.0 },
];

const Sick = () => {
    const [shopId, setShopId] = useState("");
    const [shopName, setShopName] = useState("");
    const [cashierId, setCashierId] = useState("");
    const [cashierName, setCashierName] = useState("");
    const [summaryDate, setSummaryDate] = useState("");

    const [salesSearchTerm, setSalesSearchTerm] = useState("");
    const [familycode, setFamilycode] = useState("");
    const [sales, setSales] = useState([]);
    const [filteredSales, setFilteredSales] = useState([]);

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [currencies, setCurrencies] = React.useState([]);
    const [collected, setCollected] = React.useState([]);
    const [grandTotal, setGrandTotal] = React.useState(0);

    // Helper to parse "DD-MM-YYYY" to Date
    const parseDate = (str) => {
        if (!str) return null;
        const [day, month, year] = str.split("-").map(Number);
        return new Date(year, month - 1, day);
    };

    // Convert from input type="date" (YYYY-MM-DD) to our format (DD-MM-YYYY)
    const toDisplayFormat = (isoDate) => {
        if (!isoDate) return "";
        const [year, month, day] = isoDate.split("-");
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        const getAsyncData = async () => {
            
            const createdAt = moment(new Date()).format("DD MMM YYYY");
            setSummaryDate(createdAt);

            const sessionData = await JSON.parse(
                localStorage.getItem("userData")
            );

            setShopId(sessionData.shopid);
            setShopName(sessionData.shopname);

            setCashierId(sessionData.shopid);
            setCashierName(sessionData.fullname);
            const allRates = await getAllRecords(RATE_STORE);

            const transformedData = allRates.map(item => ({
                id: item.id,
                label: item.currency,
                usdrate: item.usdrate
            }));

            setCurrencies(transformedData);

            const allSales = await getAllRecords(SALES_STORE);
            setSales(allSales);

            // Get today's date in same format as your data: "DD-MM-YYYY"
            const today = new Date();
            const day = String(today.getDate()).padStart(2, "0");
            const month = String(today.getMonth() + 1).padStart(2, "0");
            const year = today.getFullYear();
            const todayStr = `${day}-${month}-${year}`;

            // Filter sales that match today's date
            const todaysSales = allSales.filter(sale => sale.date === todayStr);

            

            const summary = calculateTotals(todaysSales, currencies);
            setCollected(summary);
            const grandTotalUSD = summary.reduce((sum, item) => sum + item.totalUSDValue, 0);
            setGrandTotal(grandTotalUSD);

            // Get today's date in YYYY-MM-DD format (required for <input type="date">)
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, "0");
            const dd = String(today.getDate()).padStart(2, "0");
            const todayInputStr = `${yyyy}-${mm}-${dd}`;

            // Set both start and end dates to today
            setStartDate(todayInputStr);
            setEndDate(todayInputStr);
        };
        getAsyncData();
    }, []);

    function calculateTotals(filteredSales, currencies) {
        const totals = {};

        // Initialize totals for all known currencies
        currencies.forEach(cur => {
            totals[cur.label] = {
                currency: cur.label,
                totalTendered: 0,
                totalUSDValue: 0,
                usdRate: cur.usdrate
            };
        });

        // Loop all sales → payments → accumulate
        filteredSales.forEach(sale => {
            sale.payments?.forEach(payment => {
                const label = payment.label;
                const tendered = parseFloat(payment.tendered || 0);
                const usdValue = parseFloat(payment.usdValue || 0);

                if (!totals[label]) {
                    // in case a currency not in currencies array appears
                    totals[label] = {
                        currency: label,
                        totalTendered: 0,
                        totalUSDValue: 0,
                        usdRate: payment.usdrate || 1
                    };
                }

                totals[label].totalTendered += tendered;
                totals[label].totalUSDValue += usdValue;
            });
        });

        // Return an array for easy display in a table
        return Object.values(totals);
    }




    useEffect(() => {
        if (!startDate && !endDate) {
            setFilteredSales(sales);
            return;
        }

        console.log("Re-render");

        const start = startDate ? parseDate(toDisplayFormat(startDate)) : null;
        const end = endDate ? parseDate(toDisplayFormat(endDate)) : null;

        console.log(sales);

        const filtered = sales.filter((sale) => {
            const saleDate = parseDate(sale.date);
            if (start && saleDate < start) return false;
            if (end && saleDate > end) return false;
            return true;
        });

        const salesWithOpened = filtered.map(sale => ({
        ...sale,
        opened: false
        }));

        setFilteredSales(salesWithOpened);
        // Example usage:
        const summary = calculateTotals(filtered, currencies);
        setCollected(summary);
        const grandTotalUSD = summary.reduce((sum, item) => sum + item.totalUSDValue, 0);
        setGrandTotal(grandTotalUSD);
    }, [startDate, endDate, sales]);

    const toggleOpen = (id) => {
    setFilteredSales(prevSales =>
        prevSales.map(sale =>
        sale.id === id ? { ...sale, opened: !sale.opened } : sale
        )
    );
    };

    const renderSale = (sales, idx) => {
        return (
            <div onClick={()=>toggleOpen(sales.id)}style={{ flexDirection: "column", marginBottom: "30px" }} key={idx}>
                <div
                    style={{
                        flexDirection: "row",
                        display: "flex",
                        justifyContent: "space-between",
                        border: "1px solid #EA6C8238",
                        padding: "10px",
                        borderRadius: "10px",
                    }}
                >
                    <div>
                        <b style={{ color: '#547FF7', fontSize: 12, fontWeight: "normal" }}>Sale Data</b>
                        <br />
                        <b>
                            {moment(sales.date, "DD-MM-YYYY").format("DD MMM YYYY")} {sales.time}
                        </b>
                        <h6 style={{ fontFamily: "Open Sans", fontSize: 15, fontWeight: "bold" }}>
                            Net Total: ${sales.nettotal}
                        </h6>
                        <b style={sales.synced == 0 ? { backgroundColor: 'gray', padding: '5px', borderRadius: '5px', fontSize: '10px', fontWeight: 'normal', color: '#ffffff' } : { backgroundColor: 'green', padding: '5px', borderRadius: '5px', fontSize: '10px', fontWeight: 'normal', color: '#ffffff' }}>{sales.synced == 0 ? "Not yet synced to server" : "Synced to server"}</b>
                        <br />
                        {sales.opened&&<>
                        <br />
                        <b style={{ color: '#547FF7', fontSize: 12, fontWeight: "normal" }}>Sale Items</b>
                        <br />
                        {sales.cartitems.map((obj) => <>
                            <div
                            key={obj.id}
                                style={{
                                    flexDirection: "row",
                                    width: "100%",
                                    marginTop: "10px",
                                    display: "flex",
                                    justifyContent: "space-between"

                                }}
                            >
                                <div style={{ width: "100%" }}>
                                    <b style={{ color: '#000000' }}>
                                        {obj.nam}
                                    </b>
                                    <h6 style={{ fontFamily: "Open Sans", color: '#00000070' }}>
                                        ${obj.price} X {obj.qty} {obj.siunit != "Singles" ? obj.siunit : ""}
                                    </h6>
                                    <b>
                                        ${obj.total}
                                    </b>
                                </div>


                            </div>
                        </>
                        )}
                        <br />
                        <b style={{ color: '#547FF7', fontSize: 12, fontWeight: "normal" }}>Sale Payments</b>
                        <br />
                        {sales.payments.map((obj) => <>
                            <div
                                style={{
                                    flexDirection: "row",
                                    width: "100%",
                                    marginTop: "10px",
                                    display: "flex",
                                    justifyContent: "space-between"

                                }}
                            >
                                <div style={{ width: "100%" }}>
                                    <b style={{ color: '#000000' }}>
                                        Currency {obj.label}
                                    </b>
                                    <h6 style={{ fontFamily: "Open Sans", color: '#00000070' }}>
                                        USD Rate ${obj.usdrate}
                                    </h6>
                                    <b>
                                        Paid ${obj.tendered}
                                    </b>
                                </div>


                            </div>
                        </>
                        )}
                        
                        </>}
                    </div>
                    <div
                        style={{
                            flexDirection: "column",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                        }}
                    >

                    </div>
                </div>
            </div>
        );
    };

    const onSaleSearchInput = (e) => {
        setSalesSearchTerm(e.target.value);
    };

    return (
        <>
            <div
                style={{
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <p style={{ fontFamily: "Open Sans", fontSize: "14" }}>
                    <b style={{ color: '#547FF7' }}>Sales Summary</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{summaryDate}
                </p>
                <span style={{ fontFamily: "Open Sans" }}>{familycode}</span>
            </div>

            <div
                style={{
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%"
                }}
            >
                <div style={{ width: "45%", flexDirection: "column" }}>
                    <label style={{ color: '#547FF7', fontSize: '13px' }}>Filter - Start Date</label>
                    <input
                        placeholder={"Search products. . ."}
                        style={{
                            width: "100%",
                            borderWidth: 1,
                            borderColor: "#EA6C82",
                            borderRadius: 5,
                            height: 50,
                            fontFamily: "Open Sans",
                            fontSize: 14,
                            paddingInline: 10,
                        }}
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                </div>
                <div style={{ width: "45%", flexDirection: "column" }}>
                    <label style={{ color: '#547FF7', fontSize: '13px' }}>Filter - End Date</label>
                    <input
                        placeholder={"Search products. . ."}
                        style={{
                            width: "100%",
                            borderWidth: 1,
                            borderColor: "#EA6C82",
                            borderRadius: 5,
                            height: 50,
                            fontFamily: "Open Sans",
                            fontSize: 14,
                            paddingInline: 10,
                        }}
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </div>
            </div>
            <div
                style={{
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <h2 className="table-title">Currency Collections</h2>
                <table className="nice-table">
                    <thead>
                        <tr>
                            <th>Currency</th>
                            <th>Collected</th>
                            <th>USD Rate</th>
                            <th>USD Equivalence</th>
                        </tr>
                    </thead>
                    <tbody>
                        {collected.map((item) => {

                            return (
                                <tr key={item.currency}>
                                    <td>{item.currency}</td>
                                    <td>{item.totalTendered.toLocaleString()}</td>
                                    <td>{item.usdRate.toLocaleString()}</td>
                                    <td>{item.totalUSDValue.toLocaleString()}</td>
                                </tr>
                            );
                        })}
                        <tr >
                            <td colSpan="3"><b>Total</b></td>
                            <td><b>{grandTotal.toLocaleString()}</b></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div
                style={{
                    width: "100%",
                    marginBottom: 30,
                    height: 60,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                }}
            >

            </div>

            <FlatList
                list={filteredSales}
                renderItem={renderSale}
                renderWhenEmpty={() => (
                    <div>
                        <p style={{ color: "gray", fontFamily: "Open Sans" }}>
                            No sales . . .
                        </p>
                    </div>
                )}
                sortBy={["id", { key: "id", descending: true }]}
                //   searchBy={["alias", "surname"]}
                //   searchTerm={searchTerm}
                search={{
                    by: ["date", "nettotal"],
                    term: salesSearchTerm,
                    caseInsensitive: true,
                }}
                style={{ marginBottom: "700px" }}
            />

            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    );
};

export default Sick;
